"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var RateInfo = /** @class */ (function (_super) {
    __extends(RateInfo, _super);
    function RateInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RateInfo.prototype.render = function () {
        var rate = this.props.rate;
        var feeAssessed = '';
        if (rate.policY_FEE_ASSESSED_CD == "a")
            feeAssessed = "At Issue";
        else if (rate.policY_FEE_ASSESSED_CD == "w")
            feeAssessed = "With Billing";
        else if (rate.policY_FEE_ASSESSED_CD == "n")
            feeAssessed = "Not Applicable";
        else
            feeAssessed = "Unknown";
        var marketingMethod = '';
        if (rate.marketinG_METHOD_CD == "a")
            marketingMethod = " Insurance policies may be purchased through Insurance Agents.";
        else if (rate.marketinG_METHOD_CD == "d")
            marketingMethod = "Insurance policies may be purchased directly from the company.";
        else if (rate.marketinG_METHOD_CD == "n")
            marketingMethod = "Not Marketed";
        else if (rate.marketinG_METHOD_CD == "b")
            marketingMethod = "Insurance policies may be purchased through Insurance Agents or directly from the company.";
        else
            marketingMethod = "unknown";
        var plan = '';
        switch (rate.plaN_CD) {
            case "F*":
                plan = "High Deductible F";
                break;
            case "J*":
                plan = "High Deductible J";
                break;
            default:
                plan = rate.plaN_CD;
                break;
        }
        var groupOffering = false;
        if (rate.grouP_CD.indexOf('Group') !== -1)
            groupOffering = true;
        return (React.createElement("div", { style: { wordWrap: 'normal' } },
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-12" },
                    React.createElement("span", { className: "font-weight-bold" }, " Extra Information: "))),
            groupOffering ? React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-12" },
                    React.createElement("span", null, " This rate is a group rate that is offered. "))) : '',
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Eligibility Requirements: ")),
                React.createElement("div", { className: "col-sm-8 border" }, (rate.eligibilitY_DS !== null) ? rate.eligibilitY_DS : 'There are no special eligibility requirements.')),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Fee Amount: ")),
                React.createElement("div", { className: "col-sm-8 border" }, (rate.policY_FEE_AM !== null) ? '$' + rate.policY_FEE_AM.toFixed(2) : '')),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Fee Frequency: ")),
                React.createElement("div", { className: "col-sm-8 border" }, feeAssessed)),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Marketing Method: ")),
                React.createElement("div", { className: "col-sm-8 border" }, marketingMethod)),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Company Name: ")),
                React.createElement("div", { className: "col-sm-8 border" }, rate.companY_NM)),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Rating Class: ")),
                React.createElement("div", { className: "col-sm-8 border" }, rate.ratinG_CLASS_NM)),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Plan Name: ")),
                React.createElement("div", { className: "col-sm-8 border" }, plan)),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Rate Amount: ")),
                React.createElement("div", { className: "col-sm-8 border" },
                    "$",
                    rate.ratE_AM.toFixed(2))),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" },
                        " Guarenteed Issue or ",
                        React.createElement("br", null),
                        "Underwritten: ")),
                React.createElement("div", { className: "col-sm-8 border" }, (rate.guaranteeD_ISSUE_CD == 'y') ? 'Underwritten' : 'Guarenteed Issue'))));
    };
    return RateInfo;
}(React.PureComponent));
;
exports.default = react_redux_1.connect()(RateInfo);
//# sourceMappingURL=RateInfo.js.map